import classNames     from 'classnames';
import { ClassValue } from 'classnames/types';
import React, { FC }  from 'react';

import { Align, FlexAlign, FlexJustify } from '../../types';
import { FlexItem, FlexItemProps }       from './FlexItem';
import { Flexbox, FlexboxProps }         from './Flexbox';


export interface CenteredContentContainerProps extends FlexboxProps {
    className?: ClassValue,
    basis?: FlexItemProps['basis'],
    alignContent?: Align,
}

const defaultProps: CenteredContentContainerProps = {
    className:    null,
    basis:        null,
    alignContent: Align.CENTER,
}

const CenteredContentContainer: FC<CenteredContentContainerProps> = ( _props ) => {

    let { children, className, alignContent, basis, ...props } = _props;

    return (
        <Flexbox
            justify={ FlexJustify.CENTER }
            align={ FlexAlign.CENTER }
            className={ classNames( { [ `text-${ alignContent }` ]: alignContent }, className ) }
            { ...props }>

            <FlexItem basis={ basis } noGrow={ basis !== null }>{ children }</FlexItem>

        </Flexbox>
    );
};

CenteredContentContainer.defaultProps = defaultProps;

export { CenteredContentContainer }
